import React, { useState } from 'react';
import { MenuItem } from '../../styles/ProjectSettingsMenu.styles';
import ProfileSettings from './ProfileSettings';
import { BackButton, ProfileSettingsWrapper } from '../../styles/ProfileSettings.styles'; // Using the styled BackButton
import ChevronIcon from '../icons/ChevronIcon'; // Import ChevronIcon

const UserSettingsMenu = ({ onSectionChange: propOnSectionChange }) => {
    const [currentSection, setCurrentSection] = useState(''); // 'profile', 'background', or ''

    const handleSectionChange = (section) => {
        setCurrentSection(section);
        // Propagate section change if the main settings component (e.g. UserProfileMenu in Navbar)
        // needs to know about the specific section being viewed, especially for 'background'.
        if (propOnSectionChange && typeof propOnSectionChange === 'function') {
            propOnSectionChange(section);
        }
    };

    // Render content based on the current section
    // This structure assumes UserSettingsMenu is rendered within a container that provides
    // the overall settings menu look (like a modal or a sidebar panel).
    if (currentSection === 'profile') {
        return (
            <ProfileSettingsWrapper> {/* Use a wrapper for controlled padding */}
                <ProfileSettings onBack={() => handleSectionChange('')} />
            </ProfileSettingsWrapper>
        );
    }

    // Default view: list of settings options
    return (
        <>
            <MenuItem onClick={() => handleSectionChange('profile')}>
                Edit Profile
            </MenuItem>
            <MenuItem onClick={() => handleSectionChange('background')}>
                Change Dashboard Background
            </MenuItem>
            <MenuItem onClick={() => handleSectionChange('ideasPlanBackground')}>
                Change Ideas Plan Background
            </MenuItem>
            {/* Other main settings items would go here */}
        </>
    );
};

export default UserSettingsMenu;
